import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';
import { MerakiNetworkFormComponent } from '@app/features/merakis/components/network-form/network-form.component';
import { MerakiSwitchFormComponent } from '@app/features/merakis/components/switch-form/switch-form.component';
import { MerakiGoProvisioningComponent } from '@app/features/merakis/modules/meraki-go-provisioning/components/meraki-go-provisioning/meraki-go-provisioning.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        SharedModule
    ],
    declarations: [
        MerakiNetworkFormComponent,
        MerakiSwitchFormComponent,
        MerakiGoProvisioningComponent
    ],
    providers: [],
    exports: [],
    bootstrap: []
})
export class MerakiGoProvisioningModule {}